module.exports = __webpack_public_path__ + "media/images/redesign-images/home/design-flatlays/design-main-0c5454ce10b19792d5269042aea91452.png";